module.exports = __webpack_public_path__ + "img/pose-f-28.ea1bebac.png";